import { render, staticRenderFns } from "./InterviewTask.vue?vue&type=template&id=71071c7d&scoped=true&"
import script from "./InterviewTask.vue?vue&type=script&lang=js&"
export * from "./InterviewTask.vue?vue&type=script&lang=js&"
import style0 from "./InterviewTask.vue?vue&type=style&index=0&id=71071c7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71071c7d",
  null
  
)

export default component.exports